module.exports = __webpack_public_path__ + "assets/img/3_1319_big.97c798b9.jpg";